import triggerTracking from '@blueprint/tracking';

import { BuyerType } from './helpers/calculate-stamp-duty';

export const trackPriceClick = (trackingCategory: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: trackingCategory,
        eventAction: 'click',
        eventLabel: 'stamp duty price'
    });
};

const getEventLabel = (buyerType: BuyerType) => {
    switch (buyerType) {
        case 'first-time-buyer':
            return 'stamp duty status - first time buyer';
        case 'not-first-time-buyer':
            return 'stamp duty status - homeowner moving';
        case 'second-home':
            return 'stamp duty status - homeowner additional';
    }
};

export const trackPropertyStatus = (
    buyerType: BuyerType,
    trackingCategory: string
) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: trackingCategory,
        eventAction: 'click',
        eventLabel: getEventLabel(buyerType)
    });
};

export const trackCalculate = (trackingCategory: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: trackingCategory,
        eventAction: 'click',
        eventLabel: 'stamp duty calculate'
    });
};
